import { useState } from 'react';

import { fetchInsights } from '../api/client';
import AsyncContent from '../components/AsyncContent';
import CtaBand from '../components/CtaBand';
import FilterChips, { ALL } from '../components/FilterChips';
import InsightCard from '../components/InsightCard';
import PageHero from '../components/PageHero';
import { useApi } from '../hooks/useApi';
import { usePageMeta } from '../hooks/usePageMeta';
import { useLanguage } from '../i18n/LanguageProvider';

export default function InsightsPage() {
  const { language, t } = useLanguage();
  const copy = t.insights;

  usePageMeta(copy.metaTitle, copy.metaDescription);

  const insights = useApi(`insights-${language}`, (signal) => fetchInsights(language, signal));
  const [filter, setFilter] = useState<string>(ALL);

  return (
    <>
      <PageHero eyebrow={copy.heroEyebrow} title={copy.heroTitle} lead={copy.heroLead} />

      <section className="section">
        <FilterChips
          label={copy.filterLabel}
          options={t.filters.insights}
          active={filter}
          onChange={setFilter}
        />
        <AsyncContent state={insights}>
          {(items) => {
            const visible = filter === ALL ? items : items.filter((item) => item.topic === filter);
            if (visible.length === 0) {
              return <div className="state">{copy.empty}</div>;
            }
            return (
              <div className="insight-grid">
                {visible.map((insight) => (
                  <InsightCard key={insight.slug} insight={insight} />
                ))}
              </div>
            );
          }}
        </AsyncContent>
      </section>

      <CtaBand eyebrow={copy.ctaEyebrow} />
    </>
  );
}
